import { render, staticRenderFns } from "./OrderGaleriaTab.vue?vue&type=template&id=6a5964be&"
import script from "./OrderGaleriaTab.vue?vue&type=script&lang=js&"
export * from "./OrderGaleriaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports